module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-MWR.29f98bba.png";